export default "__VITE_ASSET__DDomFxxm__"